import { alertController } from '@ionic/vue';

export default async function (
  message = 'Upload a WAV, MP3 or M4A to create a new song.',
  buttonText = 'Try again',
) {
  const alert = await alertController.create({
    header: 'Invalid file type',
    message,
    buttons: [
      {
        text: buttonText,
        role: 'cancel',
        handler: () => true,
      },
    ],
  });

  await alert.present();
}
